import { pipeRequest } from "./pipe-request";

export async function findCardByEmail({ emailAddress, config }) {
  const query = `query {findCards(pipeId: ${config.pipeId} search:{fieldId: "email", fieldValue: "${emailAddress}"}) {edges{node{id fields { field{id} value array_value }}}}}`;

  const result = await pipeRequest({ query, config });

  return result;
}

export async function findCardByPipeId({ pipeId, config }) {
  const query = `query { card(id: ${parseInt(pipeId)}) { id title fields { value field {id} array_value} }}`;

  const result = await pipeRequest({ query, config });

  return result;
}